import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { AbstractPageForm } from '../../pages/page-form.abstract';
import { LayeredPurchasingTopBannerType } from '../top-banner-type/layered-purchasing-top-banner-type/layered-purchasing-top-banner-type';
import { AbstractTopBannerType } from '../top-banner-type/top-banner-type.abstract';

@Component({
	selector: 'pk-broker-top-banner-alert',
	templateUrl: './top-banner-alert.component.html',
	styleUrls: ['./top-banner-alert.component.scss'],
	standalone: false,
})
export class TopBannerAlertComponent extends AbstractPageForm {
	@Input() bannerType: AbstractTopBannerType;

	@ViewChild('alert') private alert: ElementRef;

	public show = true;

	constructor() {
		super();
	}

	public async loadPageData(): Promise<void> {
		if (this.environment.name === 'demo' && !(this.bannerType instanceof LayeredPurchasingTopBannerType)) {
			this.show = false;
		}
	}

	get getClass() {
		return {
			show: this.show,
			[this.bannerType.smallBannerClassName]: true,
		};
	}

	public hideAlert(): void {
		this.show = false;
		setTimeout(() => {
			this.alert.nativeElement.remove();
		}, 1000);
	}
}
